import React from 'react';
import ReactDOM from 'react-dom';

import './css/index.scss';
import './scripts/main.js';

import Profile from './components/Profile/Profile.jsx';
import HeaderSlider from './components/HeaderSlider/HeaderSlider.jsx';

ReactDOM.render(<Profile />, document.getElementById('header-profile'));
ReactDOM.render(<HeaderSlider />, document.getElementById('header-slider'));



// WEBPACK FOOTER //
// ./index.js